const NavigationSliderTitle = ({
  title,
  color,
  nowrap
}: {
  title: string
  color?: string
  nowrap?: boolean
}) => {
  const wrapClass = nowrap ? 'text-nowrap' : ''

  return (
    <div
      className={`navigation-slider-title ${wrapClass}`}
      style={color ? { color } : undefined}
    >
      {title}
    </div>
  )
}

export default NavigationSliderTitle
